import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import ClientProfile from "./account_tabs/ClientProfile";
import ClientSettings from "./account_tabs/ClientSettings";
import UsersList from "./account_tabs/UsersList";

//Deps
import { Paper, Tab, Tabs, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";

function mapStateToProps(state) {
  return {
    //User Values
    email: state.user.currentUser.email,
    name: state.user.currentUser.name,
    role: state.user.currentUser.role,
    users: state.user.currentUser.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Tab container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: "1em" }}>
      {props.children}
    </Typography>
  );
}

//Styles
const styles = theme => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    paddingTop: "1em"
  },
  icon: {
    paddingBottom: "10px"
  },
  container: {
    padding: "2em"
  },
  key: {
    fontSize: "1.5em",
    fontWeight: "bold",
    marginTop: "1em"
  }
});

class ClientAccountPage extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, users } = this.props;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            fullWidth
            indicatorColor="secondary"
            textColor="secondary">
            <Tab icon={<PersonIcon />} className={classes.icon} />
            <Tab icon={<GroupIcon />} className={classes.icon} />
            <Tab icon={<SettingsIcon />} className={classes.icon} />
          </Tabs>
        </Paper>
        <div className={classes.container}>
          {this.state.value === 0 && (
            <TabContainer>
              <ClientProfile />
            </TabContainer>
          )}
          {this.state.value === 1 && (
            <TabContainer>
              <UsersList users={users} />
            </TabContainer>
          )}
          {this.state.value === 2 && (
            <TabContainer>
              <ClientSettings />
            </TabContainer>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ClientAccountPage));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/ClientAccountPage.js